import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "textQuestion",
  standalone: false,
})
export class TextQuestionPipe implements PipeTransform {
  transform(value: unknown): string {
    const stringValue = value as string;

    if (!stringValue) return "Não respondido";

    return stringValue;
  }
}
